import { ShoppingBag, Truck, UtensilsCrossed } from "lucide-react";
import { useBranchModal } from "@/contexts/BranchModalContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { useBrand } from "@/contexts/BrandContext";
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useEffect } from "react";

export default function OrderTypeStep() {
  const { goToStep } = useBranchModal();
  const { t } = useLanguage();
  const { brand } = useBrand();

  const { isPickUpActive, isDeliveryActive, isDineInActive } = brand;

  // Count active options
  const activeCount = [isPickUpActive, isDeliveryActive, isDineInActive].filter(Boolean).length;

  // Auto-skip: only when exactly one option is active
  useEffect(() => {
    if (activeCount === 1) {
      if (isPickUpActive) goToStep("pickup-branch");
      else if (isDeliveryActive) goToStep("delivery-map");
      // dine_in only → still show step (no dedicated step for dine-in)
    }
  }, [activeCount, isPickUpActive, isDeliveryActive, goToStep]);

  return (
    <div className="p-6">
      <DialogHeader className="mb-6">
        <DialogTitle className="text-xl font-bold text-center">
          {t("branch.howToOrder")}
        </DialogTitle>
      </DialogHeader>

      <div className={`grid gap-4 ${activeCount >= 3 ? "grid-cols-3" : activeCount === 2 ? "grid-cols-2" : "grid-cols-1"}`}>
        {/* Pickup */}
        {isPickUpActive && (
          <button
            onClick={() => goToStep("pickup-branch")}
            className="group flex flex-col items-center gap-3 p-6 rounded-xl border-2 border-border bg-card transition-all hover:border-primary hover:shadow-md"
          >
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
              <ShoppingBag className="h-7 w-7" />
            </div>
            <div className="text-center">
              <p className="font-bold text-foreground">{t("branch.pickup")}</p>
              <p className="text-xs text-muted-foreground mt-1">{t("branch.pickupDesc")}</p>
            </div>
            <span className="text-xs text-muted-foreground">{t("branch.pickupTime")}</span>
          </button>
        )}

        {/* Delivery */}
        {isDeliveryActive && (
          <button
            onClick={() => goToStep("delivery-map")}
            className="group flex flex-col items-center gap-3 p-6 rounded-xl border-2 border-border bg-card transition-all hover:border-primary hover:shadow-md"
          >
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
              <Truck className="h-7 w-7" />
            </div>
            <div className="text-center">
              <p className="font-bold text-foreground">{t("branch.delivery")}</p>
              <p className="text-xs text-muted-foreground mt-1">{t("branch.deliveryDesc")}</p>
            </div>
            <span className="text-xs text-muted-foreground">{t("branch.deliveryTime")}</span>
          </button>
        )}

        {/* Dine In */}
        {isDineInActive && (
          <button
            onClick={() => goToStep("pickup-branch")}
            className="group flex flex-col items-center gap-3 p-6 rounded-xl border-2 border-border bg-card transition-all hover:border-primary hover:shadow-md"
          >
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
              <UtensilsCrossed className="h-7 w-7" />
            </div>
            <div className="text-center">
              <p className="font-bold text-foreground">{t("branch.dinein")}</p>
              <p className="text-xs text-muted-foreground mt-1">{t("branch.dineinDesc")}</p>
            </div>
          </button>
        )}
      </div>
    </div>
  );
}
